module.exports = __webpack_public_path__ + "img/game_pc_zh.b7ca60f5.png";